module.exports = __webpack_public_path__ + "static/sawmill-b77eef903a5973d3213d1e1cde8dcc76.jpg";